import {Component, OnInit} from '@angular/core';
import {NodeBuilder} from '../../../../../../../shared/models';
import {ChatDesk, NODE_TYPE} from './chatdesk';
import {FlowManagerService} from '../../../../../services/flow-manager.service';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {tap} from 'rxjs/operators';
import {FlowBuilderService} from '../../../../../services/flowBuilder/flow-builder.service';
import { ReactiveFormsModule } from '@angular/forms';
import { ClickatellExpansionPanelComponent } from '../../../../../../../shared/components/clickatell-expansion-panel/clickatell-expansion-panel.component';
import { MatExpansionPanelTitle } from '@angular/material/expansion';
import { ClickatellFormValidationComponent } from '../../../../../../../shared/components/clickatell-form-validation/clickatell-form-validation.component';
import { ActiveFormDirective } from '../../../../../../../shared/directives/active-form/active-form.directive';
import { MatSelect, MatOption } from '@angular/material/select';
import { LoadingIconComponent } from '../../../../../../../shared/components/loading-icon/loading-icon.component';
import { CMSComponent } from '../../../../../../../shared/components/cms/cms.component';
import { NextSelectorComponent } from '../../../../json-to-from/next-selector/next-selector.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-chatdesk',
    templateUrl: './chatdesk.component.html',
    styleUrls: ['./chatdesk.component.scss'],
    imports: [ReactiveFormsModule, ClickatellExpansionPanelComponent, MatExpansionPanelTitle, ClickatellFormValidationComponent, ActiveFormDirective, MatSelect, MatOption, LoadingIconComponent, CMSComponent, NextSelectorComponent, AsyncPipe]
})
export class ChatdeskComponent extends NodeBuilder implements OnInit {

    chatDesk: ChatDesk;
    loading = true;

    chatDeskDepartments$: Observable<{ id: string, name: string }[]>;
    chatDeskIntegrations$: Observable<{ sandbox: string[], production: string[] }>;

    constructor(private flowManagerService: FlowManagerService,  private flowBuilder: FlowBuilderService) {
        super(NODE_TYPE);
    }

    ngOnInit(): void {
        this.chatDesk = new ChatDesk();

        this.chatDeskDepartments$ = this.flowManagerService.getChatDeskDepartments().pipe(
            map((departments: {}) =>
                Object.values(departments).map(department => ({
                    id: department['id'],
                    name: department['name'],
                })),
            ),
        );

        this.chatDeskIntegrations$ = this.flowManagerService.getChatDeskIntegrations().pipe(
            map((integrations: { channelTypeId, apiToken, sandbox?, production? }[]) => {
                const sandbox: string[] = [];
                const production: string[] = [];

                for (const integration of integrations) {

                    if (integration.sandbox) {
                        sandbox.push(integration.apiToken);
                        continue;
                    }

                    if (integration.production) {
                        production.push(integration.apiToken);
                    }
                }

                return {
                    sandbox,
                    production,
                };
            }),
            tap(() => {
                this.loading = false;
                this.flowBuilder.setNodeValid(this.nodeFlowDetails.stepId, this.isNodeValid);
            })
        );
    }

    set buildForm(stepData: any) {
        this.formGroup = this.chatDesk.toForm(stepData, this.canEdit);
        this.setAllNextStepValues = ['next', 'error'];
    }

    get getStepData(): {} {
        this.chatDesk.setNodeData(this.formGroup.getRawValue());
        return this.chatDesk.nodeData;
    }

    get isNodeValid(): boolean {
        return this.isValidateForm() && !this.loading;
    }
}
